import type { DistributedAsset } from '@/components/molecules/AssetsDistributionChart';
import type { FC } from 'react';
import { Flex, Skeleton } from '@eqi-investimentos/react';
import { ListItem, Table, TableContainer, Tbody, Td, Tr, UnorderedList } from '@chakra-ui/react';
import { AllocationCell } from '@/components/atoms/AllocationCell';
import { TextOverflow } from '@/components/atoms/TextOverflow';
import { IfRender } from '@/utils/jsx';
export const MyWalletCategoriesTable: FC<MyWalletCategoriesTableProps> = ({
  categories,
  isDesktop,
  colors,
  isLoading = false
}) => {
  if (isLoading) {
    return <Flex className="container__spinner" flexDir="column" justifyContent="center" alignItems="center" gap="3" w="9.375rem" h="8.75rem">
        <Skeleton w="9.375rem" h="0.9375rem" borderRadius="0.1875rem" />
        <Skeleton w="9.375rem" h="0.9375rem" borderRadius="0.1875rem" />
        <Skeleton w="9.375rem" h="0.9375rem" borderRadius="0.1875rem" />
        <Skeleton w="9.375rem" h="0.9375rem" borderRadius="0.1875rem" />
        <Skeleton w="9.375rem" h="0.9375rem" borderRadius="0.1875rem" />
      </Flex>;
  }
  return <>
      <IfRender condition={!isDesktop} data-sentry-element="IfRender" data-sentry-source-file="index.tsx">
        <UnorderedList display="flex" flex="1" flexDir="column" minH="11.25rem" gap="3.4" marginInlineStart="0" styleType="none" overflow="hidden" data-sentry-element="UnorderedList" data-sentry-source-file="index.tsx">
          {categories.map(({
          name,
          percentage,
          total
        }, i) => <ListItem key={`${name}-${total}`} display="flex" gap="3" sx={{
          '>div': {
            gap: 3.5
          },
          'div > div': {
            h: 3.5,
            w: 3.5
          },
          span: {
            fontSize: 'sm',
            lineHeight: '1.375rem'
          }
        }}>
              <AllocationCell rowIndex={i} value={percentage} colors={colors} />
              <TextOverflow fontSize="xs" lineHeight="1.125rem" fontWeight="normal">
                {name}
              </TextOverflow>
            </ListItem>)}
        </UnorderedList>
      </IfRender>
      <IfRender condition={isDesktop} data-sentry-element="IfRender" data-sentry-source-file="index.tsx">
        <TableContainer overflowX="hidden" data-sentry-element="TableContainer" data-sentry-source-file="index.tsx">
          <Table id="id_table_labels_categories_wallet_chart" variant="simple" data-sentry-element="Table" data-sentry-source-file="index.tsx">
            <Tbody data-sentry-element="Tbody" data-sentry-source-file="index.tsx">
              <Tr display="flex" flexDir="column" border="transparent" gap="1rem" data-sentry-element="Tr" data-sentry-source-file="index.tsx">
                {categories.map(({
                name,
                percentage
              }, i) => <Td key={name} display="flex" gap="4" p="0" border="transparent">
                    <AllocationCell rowIndex={i} value={percentage} minW={isDesktop ? 28 : '4.5rem'} isDesktop={isDesktop} colors={colors} />
                    <TextOverflow fontSize="sm" lineHeight="1.125rem" fontWeight="normal" color="content.secondary">
                      {name}
                    </TextOverflow>
                  </Td>)}
              </Tr>
            </Tbody>
          </Table>
        </TableContainer>
      </IfRender>
    </>;
};
export type MyWalletCategoriesTableProps = {
  categories: Omit<Required<DistributedAsset>, 'subCategory'>[];
  isDesktop: boolean;
  colors?: string[];
  isLoading?: boolean;
};